import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React, { useMemo } from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps, Popover, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import ModalContext from './ModalContext.js';
import Loadable from '../data/Loadable.js';
import CloseIconButton from './buttons/CloseIconButton.js';
import SubmitButton from './buttons/SubmitButton.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["header", "closeIcon", "actions", "loading", "submitting", "slowLoading", "slowSubmitting", "error", "submitLabel", "submitIcon", "cancelLabel", "cancelIcon", "submitDisabled", "cancelDisabled", "onSubmit", "onCancel", "size", "invertLayout", "className", "sx", "variant", "children"];
var componentRoot = createComponentSlot({
  name: "CinPopoverModal",
  slot: "Root",
  skipForwardProps: ["size"]
});

var PopoverModalBase = function PopoverModalBase(_ref) {
  var _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      closeIcon = _ref.closeIcon,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? /*#__PURE__*/React.createElement(SubmitButton, null) : _ref$actions,
      loading = _ref.loading,
      submitting = _ref.submitting,
      slowLoading = _ref.slowLoading,
      slowSubmitting = _ref.slowSubmitting,
      error = _ref.error,
      _ref$submitLabel = _ref.submitLabel,
      submitLabel = _ref$submitLabel === void 0 ? "Submit" : _ref$submitLabel,
      submitIcon = _ref.submitIcon,
      _ref$cancelLabel = _ref.cancelLabel,
      cancelLabel = _ref$cancelLabel === void 0 ? "Cancel" : _ref$cancelLabel,
      cancelIcon = _ref.cancelIcon,
      submitDisabled = _ref.submitDisabled,
      cancelDisabled = _ref.cancelDisabled,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel;
      _ref.size;
      var invertLayout = _ref.invertLayout,
      className = _ref.className;
      _ref.sx;
      _ref.variant;
      var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var modalContext = useMemo(function () {
    return {
      onCancel: onCancel,
      cancelLabel: cancelLabel,
      cancelIcon: cancelIcon,
      cancelDisabled: cancelDisabled,
      onSubmit: onSubmit,
      submitLabel: submitLabel,
      submitIcon: submitIcon,
      submitDisabled: submitDisabled,
      loading: loading,
      slowLoading: slowLoading,
      submitting: submitting,
      slowSubmitting: slowSubmitting,
      closeIcon: closeIcon
    };
  }, [onCancel, cancelLabel, cancelIcon, cancelDisabled, onSubmit, submitLabel, submitIcon, submitDisabled, loading, slowLoading, submitting, slowSubmitting, closeIcon]);
  var headerContent = header !== null ? /*#__PURE__*/React.createElement(DialogTitle, null, header, /*#__PURE__*/React.createElement(CloseIconButton, null)) : null;
  var actionsContent = actions !== null ? /*#__PURE__*/React.createElement(DialogActions, null, actions) : null;
  return /*#__PURE__*/React.createElement(Popover, _extends({
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    onClose: onCancel,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, otherProps, {
    className: classnames(componentRoot.className, className)
  }), /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: modalContext
  }, invertLayout ? actionsContent : headerContent, /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, /*#__PURE__*/React.createElement(Loadable, {
    loading: loading,
    slowLoading: slowLoading,
    error: error
  }, children)), invertLayout ? headerContent : actionsContent));
};

PopoverModalBase.propTypes = {
  header: propTypes.node,
  closeIcon: propTypes.node,
  actions: propTypes.node,
  loading: propTypes.bool,
  submitting: propTypes.bool,
  slowLoading: propTypes.bool,
  slowSubmitting: propTypes.bool,
  error: propTypes.any,
  submitLabel: propTypes.node,
  submitIcon: propTypes.node,
  cancelLabel: propTypes.node,
  cancelIcon: propTypes.node,
  submitDisabled: propTypes.bool,
  cancelDisabled: propTypes.bool,
  onSubmit: propTypes.func,
  onCancel: propTypes.func,
  size: propTypes.any,
  invertLayout: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};

var popoverMaxWidth = function popoverMaxWidth(size) {
  switch (size) {
    case "xs":
      return 444;

    case "sm":
      return 600;

    case "md":
      return 900;

    case "lg":
      return 1200;

    case "xl":
      return 1536;
  }
};

var PopoverModalRoot = styled(PopoverModalBase, componentRoot.styledOptions)(function (_ref2) {
  var theme = _ref2.theme,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "sm" : _ref2$size;
  return {
    "> .MuiPopover-paper": {
      // corresponds to styling of MUI Dialog
      width: "calc(100% - 64px)",
      maxWidth: popoverMaxWidth(size)
    },
    ".MuiDialogTitle-root": {
      position: "relative"
    },
    ".MuiDialogContent-root": {
      padding: 0,
      "> .CinLoadable-root": {
        padding: theme.spacing(2, 3)
      }
    },
    ".MuiDialogActions-root": {
      padding: theme.spacing(2, 3)
    }
  };
});
/**
 * A modal that appears attached to another element
 */

var PopoverModal = function PopoverModal(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(PopoverModalRoot, rootProps);
};

var PopoverModal$1 = PopoverModal;

export { PopoverModal$1 as default };
